import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

export default function CreateCoupon() {
  const nav = useNavigate();
  const [form, setForm] = useState({ couponCode: '', discountPercent: 10, startDate: '', endDate: '', publish: true, usageLimit: '' });
  const u = (k, v) => setForm(f => ({ ...f, [k]: v }));

  async function save() {
    const payload = { ...form };
    const raw = String(payload.usageLimit ?? '').trim();
    payload.usageLimit = raw === '' ? null : Math.max(0, Number(raw));
    if (payload.usageLimit !== null && Number.isNaN(payload.usageLimit)) payload.usageLimit = null;
    await api.post('/coupons/CreateCoupon', payload);
    nav('/pages/coupons');
  }

  return (
    <>
      <h1>Create Coupon</h1>
      <div className="card" style={{ maxWidth: 540 }}>
        <div className="prop"><label>Code</label><input value={form.couponCode} onChange={e => u('couponCode', e.target.value.toUpperCase())} /></div>
        <div className="prop">
          <label>
            <input
              type="checkbox"
              checked={Number(form.discountPercent) === 100}
              onChange={e => u('discountPercent', e.target.checked ? 100 : 10)}
            />{' '}
            Free (100% off — skips payment, downloads sent by email)
          </label>
        </div>
        <div className="prop">
          <label>Discount %</label>
          <input
            type="number"
            min="0"
            max="100"
            value={form.discountPercent}
            disabled={Number(form.discountPercent) === 100}
            onChange={e => u('discountPercent', Number(e.target.value))}
          />
        </div>
        <div className="prop">
          <label>Usage limit (leave blank for unlimited)</label>
          <input
            type="number"
            min="0"
            placeholder="∞"
            value={form.usageLimit}
            onChange={e => u('usageLimit', e.target.value)}
          />
          <small style={{ color: '#888' }}>After this many uses, the coupon stops working.</small>
        </div>
        <div className="row">
          <div className="prop" style={{ flex: 1 }}><label>Start</label><input type="date" value={form.startDate} onChange={e => u('startDate', e.target.value)} /></div>
          <div className="prop" style={{ flex: 1 }}><label>End</label><input type="date" value={form.endDate} onChange={e => u('endDate', e.target.value)} /></div>
        </div>
        <div className="prop"><label><input type="checkbox" checked={form.publish} onChange={e => u('publish', e.target.checked)} /> Active</label></div>
        <button className="btn" onClick={save}>Create</button>
      </div>
    </>
  );
}
